export const mockRenterData = {
  medianHouseholdIncome: {
    value: 85171,
    delta: 50,
  },
  population: {
    value: 600000,
    delta: 1500,
  },
  percentRenters: {
    value: 52,
    delta: -1,
  },
  petOwnership: [
    { label: 'Cats', value: 23 },
    { label: 'Dogs', value: 34 },
    { label: 'Other pets', value: 21 },
    { label: 'No pets', value: 22 },
  ],
  renterAgeDistribution: [
    { label: '18-24', value: 20 },
    { label: '25-34', value: 38 },
    { label: '35-54', value: 38 },
    { label: '55+', value: 17 },
  ],
  bedroomsSearched: [
    { label: 'Studio', value: 18 },
    { label: '1 bed', value: 36 },
    { label: '2 bed', value: 33 },
    { label: '3 bed', value: 11 },
    { label: '4+ bed', value: 4 },
  ],
  bathroomsSearched: [
    { label: 'Shared bath', value: 6 },
    { label: '1 bath', value: 38 },
    { label: '2 bath', value: 25 },
    { label: '3 bath', value: 4 },
  ],
  rentersMovedFrom: [
    { label: 'Seattle, WA', value: 24 },
    { label: 'Los Angeles, CA', value: 3 },
    { label: 'New York, NY', value: 3 },
    { label: 'Bellevue, WA', value: 2 },
    { label: 'Tacoma, WA', value: 2 },
    { label: 'Renton, WA', value: 2 },
    { label: 'Everett, WA', value: 1 },
    { label: 'Snohomish, WA', value: 1 },
    { label: 'SeaTac, WA', value: 1 },
    { label: 'Portland, OR', value: 1 },
  ],
  rentersMovedTo: [
    { label: 'Spokane, WA', value: 13.1 },
    { label: 'Portland, OR', value: 10.7 },
    { label: 'Boise, ID', value: 5 },
    { label: 'Phoenix, AZ', value: 4 },
    { label: 'Los Angeles, CA', value: 2 },
    { label: 'Bellingham, WA', value: 1 },
    { label: 'Renton, WA', value: 1 },
    { label: 'Everett, WA', value: 1 },
    { label: 'North Bend, WA', value: 1 },
    { label: 'Wenatchee, WA', value: 1 },
  ],
  estimatedAffordableRent: [
    { label: 'Under $1,000', value: 13 },
    { label: '$1,001-$1,500', value: 16 },
    { label: '$1,501-$2,000', value: 20 },
    { label: '$2,001-$3,000', value: 18 },
    { label: '$3,001-$4,000', value: 16 },
    { label: '$4,001-$5,000', value: 16 },
  ],
  annualIncome: [
    { label: '$0-$40,000', value: 10 },
    { label: '$40,001-$60,000', value: 12 },
    { label: '$60,001-$80,000', value: 17 },
    { label: '$80,001-$120,000', value: 16 },
    { label: '$120,001-$160,000', value: 20 },
    { label: '$160,001+', value: 26 },
  ],
  topAmenitySearches: [
    { label: '1+ bath', value: 26 },
    { label: 'Accepts pets', value: 20 },
    { label: 'Has parking', value: 17 },
    { label: 'In-unit laundry', value: 16 },
    { label: 'Dishwasher', value: 12 },
  ],
  topKeywordSearches: [
    { label: 'EV charger', value: 10 },
    { label: 'Short-term', value: 12 },
    { label: 'Furnished', value: 17 },
    { label: 'Balcony', value: 16 },
    { label: 'Garage', value: 20 },
  ],
};

export default mockRenterData;
